import { render, staticRenderFns } from "./GlassDamagesReparationsQuoteUploadQuestion.vue?vue&type=template&id=0828d1c4"
import script from "./GlassDamagesReparationsQuoteUploadQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassDamagesReparationsQuoteUploadQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassDamagesReparationsQuoteUploadQuestion.vue?vue&type=style&index=0&id=0828d1c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports